import { RecordModel } from "../core";
import React from "react";
import ImageUrlPicker from "../../components/fields/ImageUrlPicker";
import RecordSelect from "../../components/fields/RecordSelect";
import DestinationContentStatus from "../../components/business/DestinationContentStatus";
import { seoColumn, DESTINATION_GALLERY_ID } from "../../components/business/seo/seoColumn";


export interface IPointOfInterest {
  id: number;
  title: string;
  description: string | null;
  lat: number;
  lng: number;
}

export const PointOfInterestModel: RecordModel<IPointOfInterest> = {
  name: "Point of interest",
  path: "points-of-interest",
  selectQuery: "",
  tableQuery: "",
  toString: r => r.title,
}


export interface IAddress {
  id: string;
  location_name?: string;
  latitude: number;
  longitude: number;
}

export interface ILocation {
  id: number;
  name: string;
  slug: string;
  cover_image: string | null;
  description: string | null;
  hero_description: string | null;
  hero_image: string | null;
  why_image: string | null;
  small_ft_image: string | null;
  owning_image: string | null;
  why_excerpt: string | null;
  why_description: string | null;
  // Estimated annual appreciation, in percent (DRF sends decimals as strings).
  appreciation_low: string | null;
  appreciation_high: string | null;
}

export interface ILocationType {
  id: number;
  name: string;
  code: string;
}

export const LocationTypeModel: RecordModel<ILocationType> = {
  name: "Location Type",
  path: "location-types",
  selectQuery: "",
  tableQuery: "",
  toString(r): string {
    return r.name;
  },
  customTableMappings: {
    ...Object.fromEntries(["destination_set", "data_highlights"].map(fieldName => ([fieldName, { omit: true }]))),
  },
  customCreateFields: [
    { name: 'destination_set', component: null },
    { name: 'cover_image', component: (props) => <ImageUrlPicker {...props} galleryId={228} selectSize="hd" /> },
  ]
}

export const LocationModel: RecordModel<ILocation> = {
  name: "Destination",
  path: "destinations",
  selectQuery: "",
  tableQuery: "&expand=type",
  pageSize: 50,
  toString(r): string {
    return r.name;
  },
  fieldModels: {
    type: 'LocationType',
  },
  hasImageGalleries: true,
  primaryKeyName: 'slug',
  drawerWidth: "75%",
  customTableMappings: {
    ...Object.fromEntries(["slug", "usage_pattern", "details_gallery", "points_of_interest"].map(fieldName => ([fieldName, { omit: true }]))),
    ...Object.fromEntries(["hero_description", "why_excerpt", "why_description", "hero_image", "why_image", "small_ft_image", "owning_image"].map(fieldName => ([fieldName, { omit: true }]))),
    "name": { width: 175 },
    "type": { width: 200 },
    "description": { title: "Content status", render: r => <DestinationContentStatus destination={r} />, width: 250 }
    /*
    "hero_description": { render: r => !!r.hero_description ? <CheckCircleOutlined style={{ color: 'limegreen' }} /> : <CloseCircleOutlined style={{ color: '#f85959'}} />, width: 75  },
    "why_excerpt": { render: r => !!r.why_excerpt ? <CheckCircleOutlined style={{ color: 'limegreen' }} /> : <CloseCircleOutlined style={{ color: '#f85959'}} />, width: 75  },
    "why_description": { render: r => !!r.why_description ? <CheckCircleOutlined style={{ color: 'limegreen' }} /> : <CloseCircleOutlined style={{ color: '#f85959'}} />, width: 75  },
    "hero_image": { render: r => !!r.hero_image ? <CheckCircleOutlined style={{ color: 'limegreen' }} /> : <CloseCircleOutlined style={{ color: '#f85959'}} />, width: 75  },
    "why_image": { render: r => !!r.why_image ? <CheckCircleOutlined style={{ color: 'limegreen' }} /> : <CloseCircleOutlined style={{ color: '#f85959'}} />, width: 75  },
    "small_ft_image": { render: r => !!r.small_ft_image ? <CheckCircleOutlined style={{ color: 'limegreen' }} /> : <CloseCircleOutlined style={{ color: '#f85959'}} />, width: 75  },
    "owning_image": { render: r => !!r.owning_image ? <CheckCircleOutlined style={{ color: 'limegreen' }} /> : <CloseCircleOutlined style={{ color: '#f85959'}} />, width: 75  },
    */
  },
  customCreateFields: [
    { name: 'cover_image', component: (props) => <ImageUrlPicker {...props} galleryId={228} selectSize="hd" /> },
    { name: 'hero_image', component: (props) => <ImageUrlPicker {...props} galleryId={228} selectSize="fhd" /> },
    { name: 'why_image', component: (props) => <ImageUrlPicker {...props} galleryId={228} selectSize="fhd" /> },
    { name: 'small_ft_image', component: (props) => <ImageUrlPicker {...props} galleryId={228} selectSize="hd" /> },
    { name: 'owning_image', component: (props) => <ImageUrlPicker {...props} galleryId={228} selectSize="image" /> },
    { name: 'points_of_interest', component: (props) => <RecordSelect formName="points_of_interest" recordModel={PointOfInterestModel} mode="multiple" allowManage /> },
  ],
  formWrapperStyle: { display: 'flex', flexDirection: 'row', gap: 85, maxWidth: 1000, margin: 'auto' },
  createCenterFieldsStyle: { flex: 13 },
  createStartFieldsStyle: { flex: 5 },
  splitFieldsAtIndex: 12,
  adjacentModels: [PointOfInterestModel, LocationTypeModel],
  showsChangeLog: true,
  extraColumns: [
    seoColumn<ILocation>({
      pathFor: r => `/destinations/${r.slug}`,
      labelFor: r => r.name,
      imageFor: r => r.hero_image || r.cover_image,
      galleryId: DESTINATION_GALLERY_ID,
    }),
  ],
};
